import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TaskDossier\GetTaskDossierByIdController::__invoke
* @see app/Http/Controllers/TaskDossier/GetTaskDossierByIdController.php
* @route '/api/task-dossier/{task_dossier}'
*/
const GetTaskDossierByIdController = (args: { task_dossier: string | number | { id: string | number } } | [task_dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTaskDossierByIdController.url(args, options),
    method: 'get',
})

GetTaskDossierByIdController.definition = {
    methods: ["get","head"],
    url: '/api/task-dossier/{task_dossier}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\TaskDossier\GetTaskDossierByIdController::__invoke
* @see app/Http/Controllers/TaskDossier/GetTaskDossierByIdController.php
* @route '/api/task-dossier/{task_dossier}'
*/
GetTaskDossierByIdController.url = (args: { task_dossier: string | number | { id: string | number } } | [task_dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { task_dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { task_dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            task_dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        task_dossier: typeof args.task_dossier === 'object'
        ? args.task_dossier.id
        : args.task_dossier,
    }

    return GetTaskDossierByIdController.definition.url
            .replace('{task_dossier}', parsedArgs.task_dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TaskDossier\GetTaskDossierByIdController::__invoke
* @see app/Http/Controllers/TaskDossier/GetTaskDossierByIdController.php
* @route '/api/task-dossier/{task_dossier}'
*/
GetTaskDossierByIdController.get = (args: { task_dossier: string | number | { id: string | number } } | [task_dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTaskDossierByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\TaskDossier\GetTaskDossierByIdController::__invoke
* @see app/Http/Controllers/TaskDossier/GetTaskDossierByIdController.php
* @route '/api/task-dossier/{task_dossier}'
*/
GetTaskDossierByIdController.head = (args: { task_dossier: string | number | { id: string | number } } | [task_dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetTaskDossierByIdController.url(args, options),
    method: 'head',
})

export default GetTaskDossierByIdController